import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HeaderComponent} from './header/header.component';
import { IonicModule } from '@ionic/angular';
import {RouterModule} from "@angular/router";
import {InfoProductComponent} from "./info-product/info-product.component";
import {ExpandableComponent} from "./expandable/expandable.component";
import { SellerActivationCardComponent } from './seller-activation-card/seller-activation-card.component';
import { SellerProductActivationCardComponent } from './seller-product-activation-card/seller-product-activation-card.component';

@NgModule({
    declarations: [
        HeaderComponent,
        InfoProductComponent,
        ExpandableComponent,
        SellerActivationCardComponent,
        SellerProductActivationCardComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        RouterModule,
    ],
    exports: [HeaderComponent, InfoProductComponent, ExpandableComponent,SellerActivationCardComponent,SellerProductActivationCardComponent],
})
export class ComponentsModule { }